import { render } from "./AppFooter.vue?vue&type=template&id=0acf7c8b&scoped=true"
import script from "./_AppFooter.js?vue&type=script&lang=js&external"
export * from "./_AppFooter.js?vue&type=script&lang=js&external"

import "./_AppFooter.less?vue&type=style&index=0&id=0acf7c8b&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acf7c8b"]])

export default __exports__